import { useProvider } from '@newfront-insurance/react-provision';
import { useMemo } from 'react';

import { createNovaTransport } from '../lib/transport';
import { useNovaContext } from '../providers';

interface UseChatTransportOptions {
  onReconnectUnavailable?: (chatUuid: string) => void;
}

/**
 * Hook to create and memoize the Nova chat transport.
 * Uses context values and auth provider to configure the transport.
 * The transport is recreated when context values change.
 */
export function useChatTransport({ onReconnectUnavailable }: UseChatTransportOptions = {}) {
  const { userUuid, accountUuid, authProvider, apiEndpoint, baseUrl } = useNovaContext();
  const { getToken } = useProvider(authProvider);

  const transport = useMemo(() => {
    return createNovaTransport({
      apiEndpoint,
      baseUrl,
      getToken,
      onReconnectUnavailable,
      userUuid,
      accountUuid,
    });
  }, [accountUuid, apiEndpoint, baseUrl, getToken, onReconnectUnavailable, userUuid]);

  return transport;
}
